import { Format } from '../../../../lib/dateFns';
import { formatDateCommon } from '../../../../utils/formatters';
import type { ArticleSmallListProps } from '../../types';
import styles from './ArticleSmallList.module.scss';

export interface ArticleSmallListComponentProps extends ArticleSmallListProps {
  ImageViewComponent: React.ComponentType<{ src: string; alt: string }>;
  articleDetailPath: string;
  noImagePath: string;
}

function ArticleSmallList({
  informations,
  ImageViewComponent,
  articleDetailPath,
  noImagePath,
}: ArticleSmallListComponentProps) {
  return (
    <ul className={styles.componentStyle}>
      {informations.map((item) => (
        <li key={item.id}>
          <a
            href={`${articleDetailPath}/${item.id}`}
            className={styles.itemLink}
            data-testid={`article-link-${item.title}`}
          >
            <div className={styles.itemImage}>
              <ImageViewComponent src={item.mainImageUrl ? item.mainImageUrl : noImagePath} alt={item.title} />
            </div>

            <div className={styles.itemDetail}>
              <p className={styles.itemDate}>{formatDateCommon(item.publishedAt, Format.date)}</p>
              <h2 className={styles.itemTitle}>{item.title}</h2>
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
}

export default ArticleSmallList;
